import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { API, ITENSPORPAGINA } from 'src/app/app.config';
import { BuscarCircuitoRQ, DetalhesCircuitoRQ, PoliticaCircuitoRQ, ReservarCircuitoRQ, TarifarCircuitoRQ } from 'src/app/model/turismo/circuito.model';

@Injectable({
  providedIn: 'root'
})
export class CircuitoService {
  constructor(private http: HttpClient) { }

  buscarCircuitoPorId(id): Observable<any> {
    return this.http.get<any>(`${API}/api/Circuito/${id}`, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  alterarCircuito(alteracao: any): Observable<any> {
    return this.http.put<any>(`${API}/api/Circuito/${alteracao.Circuito.Id}`, alteracao, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  buscarCircuitos(busca: BuscarCircuitoRQ, pagina: Number): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/busca?Pagina=${pagina}&ItensPorPagina=${ITENSPORPAGINA}`, busca, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  detalhesCircuitos(detalhesCircuitoRQ: DetalhesCircuitoRQ): Observable<any> {
    return this.http.patch<any>(`${API}/api/Circuito/detalhes`, detalhesCircuitoRQ);
  }

  removerCircuito(circuito: any): Observable<any> {
    return this.http.delete<any>(`${API}/api/Circuito/${circuito}`);
  }

  tarifarCircuito(TarifarCircuitoRQ: TarifarCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/circuito/tarifar`, TarifarCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  politicaCircuito(politicaCircuitoRQ: PoliticaCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/Politica`, politicaCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  reservarCircuito(ReservarCircuitoRQ: ReservarCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/Reservar`, ReservarCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  cancelarCircuito(circuitoId: number): Observable<any> {
    return this.http.patch<any>(`${API}/api/Circuito/Cancelar/${circuitoId}`, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  noitesAdicionaisCircuito(PoliticaCircuitoRQ: PoliticaCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/NoitesAdicionais`, PoliticaCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }

  incorporacaoAbandonoCircuito(PoliticaCircuitoRQ: PoliticaCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/IncorporacionAbandono`, PoliticaCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }
  buscarValorFinalCircuito(PoliticaCircuitoRQ: PoliticaCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/ObterValores`, PoliticaCircuitoRQ);
  }
  trasladosCircuito(PoliticaCircuitoRQ: PoliticaCircuitoRQ): Observable<any> {
    return this.http.post<any>(`${API}/api/Circuito/Traslado`, PoliticaCircuitoRQ, { headers: new HttpHeaders().set('noloader', 'true') });
  }
}
